"use client";

import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";

const MIN_REFRESH_INTERVAL_MS = 30_000;

export default function CatalogFocusRevalidator() {
  const router = useRouter();
  const lastRefreshAt = useRef(0);
  const refreshing = useRef(false);

  useEffect(() => {
    const refreshCatalog = async () => {
      if (document.visibilityState !== "visible" || refreshing.current) return;
      const now = Date.now();
      if (now - lastRefreshAt.current < MIN_REFRESH_INTERVAL_MS) return;

      refreshing.current = true;
      try {
        const response = await fetch("/api/catalog/revalidate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          cache: "no-store",
        });
        if (!response.ok) {
          console.error(`Catalog revalidation endpoint returned HTTP ${response.status}.`);
          return;
        }
        lastRefreshAt.current = Date.now();
        router.refresh();
      } catch (error) {
        console.error("Could not refresh the product catalog after returning to the tab.", error);
      } finally {
        refreshing.current = false;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") void refreshCatalog();
    };

    window.addEventListener("focus", refreshCatalog);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    const interval = window.setInterval(refreshCatalog, 5 * 60 * 1000);
    return () => {
      window.removeEventListener("focus", refreshCatalog);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.clearInterval(interval);
    };
  }, [router]);

  return null;
}
